/**
 * Promise. Функция для получения дополнительной информация о дптчике dahua
 * @param {object} sensor объект сенсора
 * @returns возвращает обновленный объект сенсора с дополнительными полями
 */
const getDahuaSensorData = (sensor) => {
    const errorResponse = {
        ...sensor,
        isConfigurationFetching: false,
        firstStepError: 'Sensor is offline',
    };

    return errorResponse;
};

export default getDahuaSensorData;
